import { getTranslation } from '../i18n/index';

// Code-native diagrams describe the architecture without inventing operating data.
const diagrams = [
  '<rect x="8" y="22" width="48" height="44" rx="4"/><path d="M18 32h28M18 42h18M18 54h28M56 44h24"/><circle cx="84" cy="44" r="4"/><path class="detail-signal" d="M88 44h10l5-12 8 24 8-24 5 12h26"/><path d="M150 28v32M156 28v32M162 28v32"/>',
  '<rect x="62" y="18" width="52" height="52" rx="6"/><rect x="75" y="31" width="26" height="26" rx="2"/><path d="M74 8v10m14-10v10m14-10v10M74 70v10m14-10v10m14-10v10M52 30h10M52 44h10M52 58h10M114 30h10M114 44h10M114 58h10"/><path class="detail-signal" d="M8 44h44m72 0h44"/>',
  '<rect x="20" y="12" width="136" height="64" rx="4"/><path d="M32 64h110M32 24v40"/><path class="detail-signal" d="m36 55 20-12 20 7 20-20 20 8 22-16"/><circle cx="138" cy="22" r="4"/><path d="M68 82h40"/>',
];

function graphic(index: number): SVGSVGElement {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('viewBox', '0 0 176 88');
  svg.setAttribute('aria-hidden', 'true');
  svg.classList.add('detail-graphic');
  svg.innerHTML = diagrams[index % diagrams.length];
  return svg;
}

function flow(items: Array<{ title: string; text: string }>): HTMLOListElement {
  const list = document.createElement('ol');
  list.className = 'detail-flow';
  items.forEach((item, index) => {
    const node = document.createElement('li');
    const number = document.createElement('span');
    number.className = 'detail-flow-number';
    number.textContent = String(index + 1).padStart(2, '0');
    const title = document.createElement('strong');
    title.textContent = item.title;
    const text = document.createElement('span');
    text.className = 'detail-flow-text';
    text.textContent = item.text;
    node.append(number, title, text);
    list.append(node);
  });
  return list;
}

export function initDetailExperience(): void {
  const page = document.body.dataset.page;
  if (!['grid', 'advisory', 'sobre'].includes(page ?? '')) return;
  const t = getTranslation();
  if (page === 'grid') {
    const figure = document.querySelector('.detail-device');
    if (figure) {
      const caption = document.createElement('figcaption');
      caption.textContent = t.grid.hero.imageCaption;
      figure.append(caption);
    }
    document.querySelectorAll('.lyr').forEach((node, index) => node.prepend(graphic(index)));
  } else {
    const aside = document.querySelector('.hero-aside');
    const quote = aside?.querySelector('.hero-aside-quote');
    if (!aside || !quote) return;
    const items = page === 'advisory'
      ? t.advisory.metodo.steps.slice(0, 3).map((item) => ({ title: item.title, text: '' }))
      : t.empresa.trajetoria.branches.map((branch) => ({ title: `Tauvior ${branch.key === 'grid' ? 'Grid' : 'Advisory'}`, text: branch.kind }));
    const list = flow(items);
    list.dataset.motionCaption = page === 'advisory' ? t.advisory.metodo.sectionTag : t.empresa.trajetoria.brandLabel;
    if (page === 'sobre') list.classList.add('is-solutions');
    // Advisory e Sobre: o fluxo roda sem o botão de pausar (pausa sozinho fora da tela).
    list.dataset.motionControls = 'off';
    quote.before(list);
    if (page === 'advisory') {
      quote.textContent = t.advisory.formatos.items[0].deliverable;
      const label = aside.querySelector('.hero-aside-label');
      if (label) label.textContent = t.advisory.formatos.items[0].deliverableLabel;
      const note = aside.querySelector('.hero-aside-note');
      if (note) note.textContent = t.advisory.formatos.items[0].format;
    }
  }
}
